import { Component, inject, OnDestroy } from '@angular/core';
import {
  SendMessageQueryParams,
  TelegramAccount
} from "./types/telegram-page.types";
import { TelegramService } from "./services/telegram.service";
import { ChatTelegram } from "./types/chat-telegram.types";
import { MessageTelegram } from "./types/last-message.types";
import { TelegramFileUrlService } from "./services/telegram-file-url.service";
import { TelegramAccountsService } from "./services/telegram-accounts.service";
import { MessagesPollingService } from "./services/messages-polling.service";
import { TelegramMessagesService } from "./services/telegram-messages.service";
import { TelegramPollingService } from "./services/telegram-polling.service";
import { TelegramChatsService } from "./services/telegram-chats.service";
import { telegramPagePollingInterval } from "../../../core/models/polling-config";
import { TelegramBloggersComponent } from "./components/telegram-bloggers/telegram-bloggers.component";
import { TelegramAccountsComponent } from "./components/telegram-accounts/telegram-accounts.component";
import { TelegramChatWindowComponent } from "./components/telegram-chat-window/telegram-chat-window.component";
//TODO: Когда подключат переписать на signals
@Component({
  selector: 'app-telegram-page',
  standalone: true,
  imports: [
    TelegramBloggersComponent,
    TelegramAccountsComponent,
    TelegramChatWindowComponent
  ],
  templateUrl: './telegram-page.component.html',
  styleUrl: './telegram-page.component.scss'
})
export class TelegramPageComponent implements OnDestroy {
  private telegramService: TelegramService = inject(TelegramService);
  private messagesPollingService: MessagesPollingService = inject(MessagesPollingService);
  private telegramFileUrlService: TelegramFileUrlService = inject(TelegramFileUrlService);
  private telegramAccountsService: TelegramAccountsService = inject(TelegramAccountsService);
  private telegramMessagesService: TelegramMessagesService = inject(TelegramMessagesService);
  private telegramPollingService: TelegramPollingService = inject(TelegramPollingService);
  private telegramChatsService: TelegramChatsService = inject(TelegramChatsService);

  public selectedAccount: TelegramAccount | null = null;
  public selectedChat: ChatTelegram | null = null;
  public isVisibleBloggers: boolean = true;
  public chats: Array<ChatTelegram> = [];
  public messages: Array<MessageTelegram> = [];

  public ngOnDestroy() {
    this.messagesPollingService.stopPolling();
  }

  public toggleBlogger() {
    this.isVisibleBloggers = !this.isVisibleBloggers;
  }

  public async selectAccount(): Promise<void> {
    this.messagesPollingService.stopPolling();
    await this.telegramChatsService.setChats();
    this.chats = this.telegramChatsService.chats();
    this.selectedAccount = this.telegramAccountsService.selectedAccount();
    this.selectedChat = null;
  }

  public async handleSelectChat(chat: ChatTelegram): Promise<void> {
    this.telegramFileUrlService.clearAllUrls();
    this.selectedChat = chat;
    this.telegramChatsService.setChat(chat.id);
    this.messages = await this.telegramMessagesService.loadInitialMessages({
      chatId: chat.id,
      accountId: this.selectedAccount?.accountId
    });
    this.startMessagesPolling(chat);
  }

  public async sendMessage(sendMessageQueryParams: SendMessageQueryParams): Promise<void> {
    await this.telegramService.sendMessage(sendMessageQueryParams);
  }

  private startMessagesPolling(chat: ChatTelegram): void {
    const params = this.telegramMessagesService.setMessagesQueryParams(chat.id);

    this.telegramPollingService.getMessagesWithPolling({
      params: params,
      intervalMs: telegramPagePollingInterval,
      callback: (messages) => {
        if (this.telegramMessagesService.hasMessagesChanged(messages, this.messages)) {
          this.messages = messages;
          this.messages = this.telegramMessagesService.sortMessages(messages);
        }
      }
    });
  }
}
